export const BANNED = 'banned';
export const NEEDS_EMAIL_VERIFICATION = 'email-verification';
export const NEEDS_SSO_VERIFICATION = 'sso-verification';
export const VERIFIED = 'verified';
export const DEACTIVATED = 'deactivated';
export const DEACTIVATED_SCIM = 'deactivated-scim';
export const ACTIVE = 'active';

export const ALL_USER_STATUS = [
  BANNED,
  NEEDS_EMAIL_VERIFICATION,
  VERIFIED,
  DEACTIVATED,
  DEACTIVATED_SCIM,
];

export const USER_STATUSES_FOR_DOMAIN_LOGOUT = [
  VERIFIED,
  NEEDS_EMAIL_VERIFICATION,
];
